var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBookBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H18C25.732 0 32 6.26801 32 14V18C32 25.732 25.732 32 18 32H14C6.26801 32 0 25.732 0 18V14Z",
    fill: "#1A61F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.6666V22",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 20C9.82335 20 9.65378 19.9298 9.52876 19.8047C9.40373 19.6797 9.3335 19.5101 9.3335 19.3333V10.6667C9.3335 10.4899 9.40373 10.3203 9.52876 10.1953C9.65378 10.0702 9.82335 10 10.0002 10H13.3335C14.0407 10 14.719 10.281 15.2191 10.781C15.7192 11.2811 16.0002 11.9594 16.0002 12.6667C16.0002 11.9594 16.2811 11.2811 16.7812 10.781C17.2813 10.281 17.9596 10 18.6668 10H22.0002C22.177 10 22.3465 10.0702 22.4716 10.1953C22.5966 10.3203 22.6668 10.4899 22.6668 10.6667V19.3333C22.6668 19.5101 22.5966 19.6797 22.4716 19.8047C22.3465 19.9298 22.177 20 22.0002 20H18.0002C17.4697 20 16.961 20.2107 16.5859 20.5858C16.2109 20.9609 16.0002 21.4696 16.0002 22C16.0002 21.4696 15.7894 20.9609 15.4144 20.5858C15.0393 20.2107 14.5306 20 14.0002 20H10.0002Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBookBlue);
export default __webpack_public_path__ + "static/media/ic_book_blue.c90ff89ed39b7921c9c19c373914c188.svg";
export { ForwardRef as ReactComponent };